/* eslint-disable max-len */

import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { mapData } from './constants'

export default class DistrictMap extends PureComponent {
    static propTypes = {
        districtCode: PropTypes.string,
        scale: PropTypes.number,
    }

    static defaultProps = {
        districtCode: null,
        scale: 1,
    }

    render() {
        const { districtCode, scale } = this.props

        const ratio = 1 / scale

        const width = mapData.size.width / ratio
        const height = mapData.size.height / ratio
        const translateX = mapData.size.translate.x / ratio
        const translateY = mapData.size.translate.y / ratio

        return (
            <div style={{ width: `${width + 2}px`, height: `${height + 2}px` }}>
                <svg width={width} height={height}>
                    <g transform={`translate(${translateX},${translateY}) scale(${scale})`}>
                        <g>
                            {_.map(mapData.districts, (district) => (
                                <path
                                    key={district.code}
                                    d={district.path}
                                    id={district.id}
                                    style={{
                                        fill: districtCode === district.code ? '#29abe2' : '#ffffff',
                                        stroke: '#000000',
                                    }}
                                />
                            ))}
                        </g>
                    </g>
                </svg>
            </div>
        )
    }
}
